import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateLocation } from 'API/Location/updateLocation';

const useUpdateLocation = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (locationData) => {
        const response = await updateLocation(locationData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['Locations'] });
            queryClient.invalidateQueries({
                queryKey: ['Location', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateLocation;
